import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { ITableDataSource } from '../../../../../../shared/interfaces/table/table-data-source.interface';

@Component({
  standalone: false,
  selector: 'app-cluster-click-preview-dialog',
  templateUrl: './cluster-click-preview-dialog.component.html',
  styleUrls: ['./cluster-click-preview-dialog.component.scss'],
})
export class ClusterClickPreviewDialogComponent implements OnInit {
  resolvedData: ITableDataSource<any>;

  constructor(
    public dialogRef: MatDialogRef<ClusterClickPreviewDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private router: Router,
  ) {}

  async ngOnInit() {
    this.resolvedData = await this.data.fetchDataPromise;
    this.data.alias = this.data.alias.charAt(0).toUpperCase() + this.data.alias.slice(1);
    console.log(this.resolvedData);
  }

  itemClicked(dataSourceItem) {
    if (dataSourceItem?._id) {
      this.router.navigate([...this.data.prefixes, dataSourceItem._id]);
      this.dialogRef.close();
    }
  }
}
